import React from 'react';

import Hero from 'components/hero';
import BenefitArticle from 'components/benefit-article';

import Image1 from 'svg/illustrations/undraw_percentages_0rur.svg';
import Image2 from 'svg/illustrations/undraw_result_5583.svg';

const EmployerExamples = () => {
  return (
    <Hero layout="vertical">
      <BenefitArticle
        title="Residential Care Home Worker on a Sunday night"
        image={Image1}
      >
        <p>
          Fee is based on an agreed hourly rate for that worker x 8 hrs.
          Therefore at an average agency rate per hour is £17.00 ph the total
          fee is 8hrs x £17.00 = Total Cost per Shift is - £136:00
        </p>
        <p>
          With MyShifts it is 8 hr x £9.50 phr + £1.90 (Worker On Cost @ 20%) +
          £12.00 (MyShiftsConnection Fee) = Total Cost per shift is £103.20
        </p>
        <p>
          <strong>Myshifts saving = £32:80 per shift or 24%</strong>
        </p>
      </BenefitArticle>

      <BenefitArticle
        isLeft
        title="RN Care Home on a Saturday day shift"
        image={Image2}
      >
        <p>
          This means that as a minimum MyShifts will save you at least 19% on
          your agency cost. Fee is based on an agreed hourly rate for that
          worker x 8 hrs Therefore at an average agency rate per hour is £40.00
          ph the total fee is 8hrs x £25.00 + vat = Total Cost per Shift is -
          £384:00
        </p>
        <p>
          With MyShifts it is 8 hr x £25.00 phr + £5.00 (Worker On Cost
          @ 20%) + £25.00 (MyShiftsConnection Fee) = Total Cost per shift is
          £240:00
        </p>
        <p>
          <strong>Myshifts saving = £144:00 per shift or 37.5%</strong>
        </p>
      </BenefitArticle>
    </Hero>
  );
};

export default EmployerExamples;
